import { api } from './api';

export const authService = {
    login: async (mobile, otp) => {
        return api.post('/auth/login', { Mobile: mobile, Otp: otp });
    },

    sendOtp: async (mobile) => {
        return api.post('/auth/send-otp', { Mobile: mobile });
    },

    register: async (userData) => {
        const payload = { ...userData, role: userData.role || 2 };
        return api.post('/users', payload);
    },

    logout: async () => {
        // Handle server-side logout if necessary
        // return api.post('/auth/logout', {});
    },

    verifyOtp: async (mobileNumber, otp) => {
        return api.post('/auth/verify-otp', { mobileNumber, otp });
    }
};
